import React from "react";
import {css, cx} from "@panda/css";

import {BrandCalendarIcon, ClockIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate, pluralize} from "@pg-mono/string-utils";
import {ARTICLE_TEST_IDS} from "@pg-mono/test-ids";

import {IArticleDetailArticle} from "../../actions/IArticleDetail";
import {ArticleRating} from "./ArticleRating";

interface IProps {
    article: IArticleDetailArticle;
    className?: string;
}

export const ArticleDetailInfoPanel: React.FunctionComponent<IProps> = (props) => {
    const {update_date, ratings, estimated_reading_time, show_reading_time, id: articleID} = props.article;
    const minutesPlural = pluralize(["minuta", "minuty", "minut"]);

    return (
        <div className={cx(articleDetailInfoPanel, props.className)}>
            <div className={leftPanel}>
                <Text as="div" variant="info_txt_1" className={timeInfoText} dataTestId={ARTICLE_TEST_IDS.PUBLICATION_LINE}>
                    <span className={metaItem}>
                        <BrandCalendarIcon size="2.4" wrapperSize="1.8" wrapperColor="transparent" className={calendarIconStyle} />
                        {formatDate(update_date, dateTimeFormat.shortDate)}
                    </span>
                    {show_reading_time && !!estimated_reading_time && (
                        <span className={metaItem}>
                            <ClockIcon size="2.4" className={clockIconStyle} />
                            {estimated_reading_time} {minutesPlural(estimated_reading_time)}
                        </span>
                    )}
                </Text>
            </div>
            <ArticleRating articleId={articleID} ratings={ratings} />
        </div>
    );
};

const timeInfoText = css({
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    columnGap: 2
});

const articleDetailInfoPanel = css({
    mt: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    columnGap: 2,
    width: "100%",
    flexBasis: "100%",
    md: {
        mt: 0
    }
});

const leftPanel = css({
    alignItems: "center",
    display: "flex",
    flex: "1 1 auto",
    minWidth: 0
});

const metaItem = css({
    display: "inline-flex",
    alignItems: "center"
});

const calendarIconStyle = css({
    mr: 1
});

const clockIconStyle = css({
    mr: "1.2rem"
});
import React from "react";
import {css, cx} from "@panda/css";

import {BrandCalendarIcon, ClockIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate, pluralize} from "@pg-mono/string-utils";
import {ARTICLE_TEST_IDS} from "@pg-mono/test-ids";

import {IArticleDetailArticle} from "../../actions/IArticleDetail";
import {ArticleRating} from "./ArticleRating";

interface IProps {
    article: IArticleDetailArticle;
    className?: string;
}

export const ArticleDetailInfoPanel: React.FunctionComponent<IProps> = (props) => {
    const {update_date, ratings, estimated_reading_time, show_reading_time, id: articleID} = props.article;
    const minutesPlural = pluralize(["minuta", "minuty", "minut"]);

    return (
        <div className={cx(articleDetailInfoPanel, props.className)}>
            <div className={leftPanel}>
                <Text as="div" variant="info_txt_1" className={timeInfoText} dataTestId={ARTICLE_TEST_IDS.PUBLICATION_LINE}>
                    <span className={metaItem}>
                        <BrandCalendarIcon size="2.4" wrapperSize="1.8" wrapperColor="transparent" className={calendarIconStyle} />
                        {formatDate(update_date, dateTimeFormat.shortDate)}
                    </span>
                    {show_reading_time && !!estimated_reading_time && (
                        <span className={metaItem}>
                            <ClockIcon size="2.4" className={clockIconStyle} />
                            {estimated_reading_time} {minutesPlural(estimated_reading_time)}
                        </span>
                    )}
                </Text>
            </div>
            <ArticleRating articleId={articleID} ratings={ratings} />
        </div>
    );
};

const timeInfoText = css({
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    columnGap: 2
});

const articleDetailInfoPanel = css({
    mt: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    columnGap: 2,
    width: "100%",
    flexBasis: "100%",
    md: {
        mt: 0
    }
});

const leftPanel = css({
    alignItems: "center",
    display: "flex",
    flex: "1 1 auto",
    minWidth: 0
});

const metaItem = css({
    display: "inline-flex",
    alignItems: "center"
});

const calendarIconStyle = css({
    mr: 1
});

const clockIconStyle = css({
    mr: "1.2rem"
});
